import { Modal } from 'antd';
import { FC } from 'react';

interface EmptyTaskQueueDialogProps {
  open: boolean;
  queueName: string;
  onClose: () => void;
}

export const EmptyTaskQueueDialog: FC<EmptyTaskQueueDialogProps> = ({
  open,
  queueName,
  onClose,
}) => {
  return (
    <Modal
      title="Task Queue Empty"
      open={open}
      onOk={onClose}
      onCancel={onClose}
    >
      <p>
        Pipeline <b>{queueName}</b> no longer has any tasks available. Please
        choose a different queue.
      </p>
    </Modal>
  );
};
